import React from 'react';
import { List } from '@thd-olt-component-react/list';
import { arrayOf, shape, string } from 'prop-types';
import { DocumentLink } from '../DocumentLink/DocumentLink';
import './document-list.scss';

export const publish = (target) => {
  const eventData = {
    component: 'info-and-guides',
    section: 'product-overview',
    target
  };
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('zone-b.click', eventData);
  }
};

export const DocumentList = ({ documents }) => {
  return (
    <List className="document-list-wrapper">
      {documents.map((document) => {
        const { name, url } = document;
        return (
          <List.Item key={name} onclick={() => { publish(name); }}>
            <DocumentLink name={name} url={url} />
          </List.Item>
        );
      })}
    </List>
  );
};

DocumentList.displayName = 'DocumentList';

DocumentList.propTypes = {
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired
};
